// Top-level router for the billing admin screens. Mounted from
// SuperuserApp.jsx.

import React from 'react'
import { NavLink, Route, Switch } from 'react-router-dom'
import { Menu, Segment } from 'semantic-ui-react'

import BillingSubscriptionsListContainer from 'components/superuser/billing/BillingSubscriptionsListContainer'
import BillingSubscriptionForm   from 'components/superuser/billing/BillingSubscriptionForm'
import NewBillingSubscription    from 'components/superuser/billing/NewBillingSubscription'
import SubscriptionDetail        from 'components/superuser/billing/SubscriptionDetail'
import BillingInvoicesListContainer from 'components/superuser/billing/BillingInvoicesListContainer'
import InvoiceDetail             from 'components/superuser/billing/InvoiceDetail'
import BillingRunsListContainer  from 'components/superuser/billing/BillingRunsListContainer'
import SupplierConfigContainer   from 'components/superuser/billing/SupplierConfigContainer'

const Tabs = () => (
  <Menu pointing secondary>
    <Menu.Item as={NavLink} to={Routes.superuser_billing_subscriptions_path()}>
      {I18n.t('superuser.billing.tabs.subscriptions', { defaultValue: 'Subscriptions' })}
    </Menu.Item>
    <Menu.Item as={NavLink} to={Routes.superuser_billing_invoices_path()}>
      {I18n.t('superuser.billing.tabs.invoices', { defaultValue: 'Invoices' })}
    </Menu.Item>
    <Menu.Item as={NavLink} to={Routes.superuser_billing_runs_path()}>
      {I18n.t('superuser.billing.tabs.billing_runs', { defaultValue: 'Billing runs' })}
    </Menu.Item>
    <Menu.Item as={NavLink} to={Routes.superuser_billing_supplier_config_path()}>
      {I18n.t('superuser.billing.tabs.supplier', { defaultValue: 'Supplier' })}
    </Menu.Item>
  </Menu>
)

export default function Billing () {
  return (
    <Segment basic className="main-body">
      <Tabs/>
      <Switch>
        <Route exact path={Routes.new_superuser_billing_subscription_path()} component={NewBillingSubscription}/>
        <Route exact path={Routes.edit_superuser_billing_subscription_path({ id: ':id', _options: true })}
               render={({ match }) => <BillingSubscriptionForm entityId={match.params.id}/>}/>
        <Route exact path={Routes.superuser_billing_subscription_path({ id: ':id', _options: true })}
               render={({ match }) => <SubscriptionDetail subscriptionId={match.params.id}/>}/>
        <Route exact path={Routes.superuser_billing_subscriptions_path()} component={BillingSubscriptionsListContainer}/>

        <Route exact path={Routes.superuser_billing_invoice_path({ id: ':id', _options: true })}
               render={({ match }) => <InvoiceDetail invoiceId={match.params.id}/>}/>
        <Route exact path={Routes.superuser_billing_invoices_path()} component={BillingInvoicesListContainer}/>

        <Route exact path={Routes.superuser_billing_runs_path()} component={BillingRunsListContainer}/>
        <Route exact path={Routes.superuser_billing_supplier_config_path()} component={SupplierConfigContainer}/>
      </Switch>
    </Segment>
  )
}
